import axios from '../utils/axios'

export const getInstitutions = async (page: number = 0, size: number = 10) => {
    try {
        const {data} = await axios.get(`institutions/list?page=${page}&size=${size}`);
        return data;
    } catch (error) {
        throw error;
    }
}

export const postInstitution = async (body: InstitutionType) => {
    try {
        const res = await axios.post('institutions', body);
        return res;
    } catch (error) {
        throw error;
    }
}

export const updateInstitution = async (institutionId: number, data: any) => {
    try {
        const res = await axios.patch(`institutions/${institutionId}`, data);
        return res;
    } catch (error) {
        throw error;
    }
}

export const deleteInstitution = async (institutionId: number) => {
    try {
        const res = await axios.delete(`institutions/${institutionId}`);
        return res;
    } catch (error) {
        throw error;
    }
}

export const getInstitutionCodes = async () => {
    try {
      const { data } = await axios.get(`institutions/codes`);
      return data.data ?? [];
    } catch (error) {
      throw error;
    }
  };